import { render, staticRenderFns } from "./claims.page.vue?vue&type=template&id=a5478460&"
import script from "./claims.page.vue?vue&type=script&lang=ts&"
export * from "./claims.page.vue?vue&type=script&lang=ts&"
import style0 from "./claims.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports